const baseURL = process.env.VUE_APP_ROOT_API || 'http://localhost:5000'

const getDefinitionApiEndpoint = (api) =>
  `${baseURL}/definitions/resources/${api}/api.yaml`

export { getDefinitionApiEndpoint }
